import { apiClient as axios, publicClient } from '../lib/authClient';

const API_URL = `/ticket-statuses`;
const PUBLIC_API_URL = ''; // publicClient already handles the base

// Get all statuses (Auth required)
export const getAllTicketStatuses = async (params = {}) => {
    try {
        const response = await axios.get(API_URL, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching ticket statuses:', error);
        throw error;
    }
};

// Get all statuses (Public)
export const getPublicTicketStatuses = async (params = {}) => {
    try {
        const response = await publicClient.get(`/ticket-statuses`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching public ticket statuses:', error);
        return [];
    }
};

// Create status
export const createTicketStatus = async (statusData) => {
    try {
        const response = await axios.post(API_URL, statusData);
        return response.data;
    } catch (error) {
        console.error('Error creating ticket status:', error);
        throw error;
    }
};

// Update status
export const updateTicketStatus = async (id, statusData) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, statusData);
        return response.data;
    } catch (error) {
        console.error('Error updating ticket status:', error);
        throw error;
    }
};

// Delete status
export const deleteTicketStatus = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting ticket status:', error);
        throw error;
    }
};
